module.exports = __webpack_public_path__ + "77de4664f1d6ee65b62b1b5fe40de369.png";